export const CONSTANTS = {
    FIREBASE: {
        INVOICES: {
            NAME: "invoices",
            COLUMNS: {
                AMOUNT: "amount"
            }
        },
        COLLECTIONS: {
            ESTIMATES: "estimates"
        }
    },
    ERRORS: {
        PAYMENT_INTENT_FAILED: "Unable to initialize payment. Please try refreshing the page.",
        PAYMENT_INTENT_NETWORK: "Unable to connect to payment service. Please check your connection and try again.",
        PAYMENT_INTENT_INVALID: "Received an invalid response from the payment service. Please try again."
    },
    LABELS: {
        AMOUNT_PAID: "Amount Paid:",
        REMAINING_BALANCE: "Remaining Balance:",
        DEPOSIT_SUCCESS_MESSAGE: "Thank you for your solar screen deposit payment! Your installation is now confirmed.",
        DEPOSIT_NEXT_STEPS_TITLE: "What happens next?",
        DEPOSIT_NEXT_STEP_1: "Our team will contact you within 1-2 business days to schedule your installation",
        DEPOSIT_NEXT_STEP_2: "We'll confirm your selected mesh and frame colors",
        DEPOSIT_NEXT_STEP_3: "The remaining balance will be due upon completion of installation",
        REMAINING_PAYMENTS: "Remaining Payments",
        PAY_NEXT_INVOICE: "Pay Now",
        ALL_PAYMENTS_COMPLETE: "All payments have been completed. Thank you!",
        PAYMENTS_REMAINING_SUMMARY: "payments remaining"
    }
}